(function () {
    // sortowanie po data-sort; tresc tabeli jest juz w HTML z serwera
    var tabela = document.querySelector('[data-rekordy-przerw-tabela]');
    if (!tabela) { return; }
    var tbody = tabela.tBodies[0], kier = { 1: -1 };
    tabela.querySelectorAll('[data-rekordy-przerw-sort]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var idx = Number(btn.getAttribute('data-rekordy-przerw-sort'));
            kier[idx] = kier[idx] === 1 ? -1 : 1;
            var d = kier[idx], tekstowa = idx === 2 || idx === 3;
            var wiersze = Array.prototype.slice.call(tbody.rows);
            wiersze.sort(function (a, b) {
                var va = a.cells[idx].getAttribute('data-sort'), vb = b.cells[idx].getAttribute('data-sort');
                if (tekstowa) { return d * (va < vb ? -1 : (va > vb ? 1 : 0)); }
                return d * (Number(va) - Number(vb));
            });
            wiersze.forEach(function (w) { tbody.appendChild(w); });
            tabela.querySelectorAll('th').forEach(function (th) { th.setAttribute('aria-sort', 'none'); });
            btn.parentNode.setAttribute('aria-sort', d === 1 ? 'ascending' : 'descending');
        });
    });
})();
